// @utils/fetchCms.js
// Edge-safe: used by server components AND middleware.
export async function fetchCms(path, { revalidate = 180, timeout = 5000 } = {}) {
  const url = `${process.env.BASE_URL}${path}`
  if (!process.env.BASE_URL || url.includes('undefined')) {
    throw new Error(`Invalid URL: "${url}" — check your env variables`)
  }

  const key = process.env.RSTBASE_API_KEY
  if (!key) console.error('❌ RSTBASE_API_KEY is not set')

  const controller = new AbortController()
  const timer = setTimeout(() => controller.abort(), timeout)
  const isProd = process.env.NODE_ENV === 'production'

  try {
    const response = await fetch(url, {
      headers: { apikey: key },
      signal: controller.signal,
      ...(isProd ? { next: { revalidate } } : { cache: 'no-store' }),
    })
    if (!response.ok) throw new Error(`HTTP ${response.status} from ${url}`)
    return await response.json()
  } catch (err) {
    if (err.name === 'AbortError') throw new Error(`Fetch timed out after ${timeout}ms: ${url}`)
    throw err
  } finally {
    clearTimeout(timer)
  }
}